import React from 'react';
import RainEffect from './RainEffect';
import SnowEffect from './SnowEffect';
import FogEffect from './FogEffect';
import CloudEffect from './CloudEffect';
import StormEffect from './StormEffect';

interface WeatherEffectProps {
  effect: string | null;
  isDay?: boolean;
}

const WeatherEffect: React.FC<WeatherEffectProps> = ({ effect, isDay }) => {
  switch (effect) {
    case 'rain':
      return <RainEffect isDay={isDay} />;
    case 'snow':
      return <SnowEffect />;
    case 'fog':
      return <FogEffect isDay={isDay} />;
    case 'cloudy':
      return <CloudEffect />;
    case 'storm':
      return <StormEffect isDay={isDay} />;
    default:
      return null;
  }
};

export default WeatherEffect;
